import $ from '../tools/Dom';
import Viewport from '../tools/Viewport';
import * as Events from '../lib/events';
import TweenMax from 'gsap/TweenMaxBase.js';

export default (el, data) => {
    const dom = $(el);
    const items = dom.find('[data-item]');

    const onFocus = e => {
        console.log('onFocus');
        const node = e.triggerTarget;

        $('[aria-selected="true"]').attr('aria-selected', false);

        $(node).attr('aria-selected', true);
    };

    const togglePanel = (panel, shouldHide) => {
        const node = panel.get(0);

        panel.attr('aria-hidden', shouldHide);
        panel.parent('[data-item]').attr('open', !shouldHide);
        TweenMax.killTweensOf(node);

        if (shouldHide) {
            TweenMax.to(node, 0.25, { height: 0, clearProps: 'all' });
        } else {
            TweenMax.set(node, { height: 'auto', display: 'block' });
            TweenMax.from(node, 0.25, { height: 0 });
        }
    };

    const onClick = e => {
        console.log(e);
        const button = $(e.triggerTarget);
        const currentState = button.attr('aria-expanded') === 'true';

        button.attr('aria-expanded', !currentState);

        togglePanel(button.parent('[data-item]').find('[data-contents]'), currentState);
    };

    const enhanceItem = (node, i) => {
        const item = $(node);
        const question = item.find('[data-question]');
        const contents = item.find('[data-contents]');

        question.html(`<button>${question.html()}</button>`)

        // item.prepend('<button></button>');
        const button = question.find('button');

        button.attr({
            class: 'js-button',
            id: `accordion-${data.id}_tab-${i}`,
            'aria-controls': `accordion-${data.id}_panel-${i}`,
            'aria-expanded': false,

            'aria-selected': false
        });

        // button.html(question.html());

        button.append('<div class="b:faq__arrow l-pos-abs"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="11" viewBox="0 0 24 11"><g><g><g><path fill="#5F0C2C" d="M24 1.6c0 .5-.2 1-.7 1.4L12 10.9.7 3C0 2.5-.2 1.4.3.7S1.9-.2 2.6.3L12 6.9 21.4.3c.7-.5 1.8-.3 2.3.4.2.3.3.6.3.9z"/></g></g></g></svg></div>');

        contents.attr({
            id: `accordion-${data.id}_panel-${i}`,
            'aria-labelledby': `accordion-${data.id}_tab-${i}`,
            'aria-hidden': true
        });

        // question.addClass('u-sr-only');
    };

    const init = () => {
        // dom.attr({
        //     role: 'tablist',
        //     'aria-multiselectable': true
        // });

        items.each(enhanceItem);

        dom.on('click', '.js-button', onClick);
        dom.on('focusin', '.js-button', onFocus);
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};
